import axios from "../components/UtilityHelpers/AxiosHelper";

class ApiServiceClass {

    getCookie = (name: string): string | undefined => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop()?.split(';').shift();
    }

    saveInitDraft = async () => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.post("create-draft-request", JSON.stringify([]),
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    getDraft = async () => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("retrivedraft",
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    getRequestByMemberID = async () => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-request-by-memberid",
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    getRequestForApproval = async (maxbudget: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-request-for-approval?maxbudget=" + maxbudget,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;        
    }

    getArchivedRequestForApproval = async (maxbudget: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-archived-request-for-approval?maxbudget=" + maxbudget,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;        
    }

    addItem = async (formData: FormData) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.post("add-item", formData,
            {
                headers: { 'Content-Type': 'multipart/form-data', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    generateReport  = async (formData: FormData) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.post("generate-report", formData, 
            {
                headers: { 'Content-Type': 'multipart/form-data', 'X-CSRF-TOKEN': csrfToken },
                responseType: 'blob',
                withCredentials: true,
            });

        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "ops_report.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(link.href);
    }

    saveDraft = async (formData: FormData) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.post("save-draft", formData,
            {
                headers: { 'Content-Type': 'multipart/form-data', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    submitRequest = async (formData: FormData) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.post("submit-request", formData,
            {
                headers: { 'Content-Type': 'multipart/form-data', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    submitRequestNoStatusChange = async (formData: FormData) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.post("submit-request-no-status-change", formData,
            {
                headers: { 'Content-Type': 'multipart/form-data', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }    

    changeMemberNotificationType = async (formData: FormData) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.post("change-notification-type", formData,
            {
                headers: { 'Content-Type': 'multipart/form-data', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    changeRequestStatus = async (formData: FormData) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.post("change-request-status", formData,
            {
                headers: { 'Content-Type': 'multipart/form-data', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    updateItem = async (formData: FormData) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.post("update-item", formData,
            {
                headers: { 'Content-Type': 'multipart/form-data', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    getSuppliers = async () => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-suppliers",
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    getBudgetDetails = async () => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-budget-details",
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    updateBudget = async (formData: FormData) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.post("update-budget", formData,
            {
                headers: { 'Content-Type': 'multipart/form-data', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    getRequestForSlipchart = async () => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-request-for-slipchart",
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    getRequestByID = async (requestID: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-request-by-id?id=" + requestID,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    getRequestDetailsByID = async (requestID: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-request-details-by-id?id=" + requestID,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }  

    getCommentsByRequestID = async (requestID: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-comments-byrequest-id?id=" + requestID,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    addComment = async (formData: FormData) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.post("add-comment", formData,
            {
                headers: { 'Content-Type': 'multipart/form-data', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }


    getItemsByRequestID = async (requestID: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-items-byrequest-id?id=" + requestID,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    getMembersByRequestID = async (requestID: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-members-by-requestid?id=" + requestID,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    getMembersNotInRequest = async (requestID: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-members-notin-request?id=" + requestID,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response.data;
    }

    deleteMemberFromRequest = async (requestID: number, memberID: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.delete("delete-member-from-request?requestID=" + requestID + "&memberID=" + memberID,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    deleteItemFromRequest = async (itemID: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.delete("delete-item?id=" + itemID,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    changePrimaryRequestor = async (requestID: number, memberID: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("change-primary-requestor?requestID=" + requestID + "&memberID=" + memberID,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    addMemberToRequest = async (requestID: number, memberID: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("add-member-to-request?requestID=" + requestID + "&memberID=" + memberID,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    deleteRequest = async (requestID: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.delete("delete-request?id=" + requestID,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    getCategoryTypes = async () => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-category-types",
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

    getCategories = async () => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("get-categories",
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,                
            });

        return response;
    }

    downloadFile = async (fileID: number) => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("download-quote/" + fileID,
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
                responseType: 'blob',
            });

        return response;
    }

    archivePreviousYearRequests = async () => {
        const csrfToken = this.getCookie('csrf_access_token');
        const response = await axios.get("archive-previous-year-requests",
            {
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrfToken },
                withCredentials: true,
            });

        return response;
    }

}

export default new ApiServiceClass();